import { HttpBadStatusCodeError, TPrimitives } from '@cian/peperrors/shared';

import { TThunkAction } from '../../types/redux';
import {
  fetchLeaveContacts,
  ILeaveContactsRequest,
  ILeaveContactsResponse200 as IRes200,
  ILeaveContactsResponse400 as IRes400,
} from '../../repositories/e2e-deal-form/v2/leave-contacts';
import { TLeaveContactsSendFromAllowedValues } from '../../types/promoInfo';
import { TRequestReturnValue } from '../../types/requestReturnValue';

/**
 * Отправка заявки на все, кроме консультации (например, на мастер-класс).
 *
 * NOTE Сейчас за все подобные заявки отвечает ручка /v2/leave-contacts/ (именно v2),
 * но в будущем появится отдельная ручка для такого рода заявок.
 */
export const leaveContacts =
  (
    parameters: ILeaveContactsRequest & { sentFrom: TLeaveContactsSendFromAllowedValues },
  ): TThunkAction<Promise<TRequestReturnValue>> =>
  async (dispatch, getState, context) => {
    const userId = getState().user.userId;

    try {
      const result = await fetchLeaveContacts<IRes200, IRes400>({ httpApi: context.httpApi, parameters });

      if (result.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          message: `${result.response.message}`,
          domain: 'leaveContacts.ts',
          statusCode: result.statusCode,
          details: {
            errors: result.response.errors as TPrimitives,
          },
        });
      }

      return { data: undefined };
    } catch (error) {
      const isBasStatusCodeError = error instanceof HttpBadStatusCodeError;

      if (!isBasStatusCodeError) {
        context.logger.error(error, {
          message: 'Ошибка при отправке контактов, ручка e2e-deal-form/v2/leave-contacts/',
          degradation: 'Ошибка в форме, пользователь может повторить попытку',
          domain: 'leaveContacts.ts',
          details: { userId },
        });
      }

      return { error: new Error(isBasStatusCodeError ? error.message : undefined) };
    }
  };
